import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { Sparkles, Loader2 } from "lucide-react";

export default function LoginPage() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();
  const [sp] = useSearchParams();
  const next = sp.get("next") || "/espace";

  const submit = async (e) => {
    e.preventDefault(); setError(""); setLoading(true);
    const r = await login(email, password);
    setLoading(false);
    if (r.ok) nav(next); else setError(r.error || "Erreur d'authentification");
  };

  return (
    <div className="container-x py-16 grid lg:grid-cols-2 gap-14 items-center min-h-[70vh]">
      <div className="hidden lg:block">
        <div className="grid place-items-center h-14 w-14 rounded-2xl bg-brand-500 text-white shadow-sm mb-6"><Sparkles /></div>
        <h1 className="font-display text-4xl xl:text-5xl font-bold text-slate-900 tracking-tight">Bon retour parmi nous.</h1>
        <p className="mt-4 text-slate-600 leading-relaxed text-lg max-w-md">Retrouvez vos formations, votre progression et vos ressources. Le développement cérébral n'attend pas.</p>
      </div>
      <div className="max-w-md w-full mx-auto">
        <div className="card-soft p-8" data-testid="login-form">
          <h2 className="font-display font-bold text-2xl text-slate-900">Se connecter</h2>
          <p className="text-sm text-slate-500 mt-1">Bienvenue dans votre espace Beehive.</p>
          <form onSubmit={submit} className="mt-6 space-y-3">
            <Input data-testid="login-email" type="email" required placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} />
            <Input data-testid="login-password" type="password" required placeholder="Mot de passe" value={password} onChange={(e) => setPassword(e.target.value)} />
            {error && <div className="text-sm text-red-600" data-testid="login-error">{error}</div>}
            <button data-testid="login-submit" disabled={loading} className="btn-primary w-full disabled:opacity-70">
              {loading ? <Loader2 size={16} className="animate-spin" /> : "Se connecter"}
            </button>
          </form>
          <p className="text-sm text-slate-600 text-center mt-6">Pas encore de compte ? <Link to="/inscription" className="link-inline">Créer un compte</Link></p>
        </div>
      </div>
    </div>
  );
}
